import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import "./About.css";

export default function About() {
  const { t } = useTranslation();

  return (
    <section className="about" id="about">
      <div className="about-overlay"></div> {/* طبقة التعتيم */}
      
      <motion.div 
        className="about-container"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        <div className="about-content-flex">
          
          {/* الجانب الأيسر: الكلام والمهارات */}
          <div className="about-info">
            <motion.h2
              initial={{ x: -50, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ delay: 0.2 }}
            >
              {t('nav_about')}
            </motion.h2>
            
            <p className="about-description">
              {t('about_text')}
            </p>

            <div className="skills-section">
              <h3>{t('skills_title')}</h3>
              <div className="skills-grid">
                {["React.js", "JavaScript", "CSS", "Git", "GIS", "BOOTSTRAB"].map((skill, index) => (
                  <motion.span 
                    key={index}
                    whileHover={{ scale: 1.1, color: "var(--primary-color)" }}
                  >
                    {skill}
                  </motion.span>
                ))}
              </div>
            </div>
          </div>

          {/* الجانب الأيمن: اللوجو */}
          <motion.div 
            className="about-visual"
            initial={{ x: 50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.4 }}
          >
            <div className="logo-wrapper">
              <img src="logo.png" alt="Ziad Logo" />
            </div>
          </motion.div>

        </div>
      </motion.div>
    </section>
  );
}